export const PERMISSION_ERROR_MESSAGE = 'You do not have permission to access this page.'

// Modal Title and Labels
export const MODAL_TITLE = 'Create New Alias User'
export const MODAL_DESCRIPTION = 'Create a new alias user for organization:'
export const SELECT_USER_LABEL = 'Select HiMarley User:'
export const LOADING_USERS_TEXT = 'Loading users...'

// Button Labels
export const CANCEL_BUTTON_TEXT = 'Cancel'
export const SUBMIT_BUTTON_TEXT = 'Submit'

// Page Title and Description
export const PAGE_TITLE = 'Alias User Management'
export const PAGE_DESCRIPTION = 'Select the organization from the dropdown above to begin managing alias users for that org.'
export const ORGANIZATION_LABEL = 'Organization: '

// Table Headers
export const TABLE_NAME_HEADER = 'Name'
export const TABLE_EMAIL_HEADER = 'Email'
export const TABLE_STATUS_HEADER = 'Status'

// Status Labels
export const STATUS_ACTIVATED = 'Activated'
export const STATUS_DEACTIVATED = 'Deactivated'

// Empty State
export const NO_USERS_FOUND = 'No users found.'

// Status Change Dialog
export const STATUS_CHANGE_DIALOG_TITLE = 'Confirm Status Change'
export const STATUS_CHANGE_DIALOG_PREFIX = 'Are you sure you want to '
export const STATUS_CHANGE_DEACTIVATE = 'deactivate'
export const STATUS_CHANGE_ACTIVATE = 'activate'
export const STATUS_CHANGE_CONFIRM = 'Confirm'

// Loading States
export const LOADING_PERMISSIONS = 'Loading user permissions...'

// Action Buttons
export const CREATE_ALIAS_USER = 'Create Alias User'
